import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const HistoryIcon: FC<IconProps> = ({ className }) => (
    <svg className={className} width="24" height="24" fill="none">
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m9.5 14.5 1.666 1.667 3.333-3.334m-1.666-8.332-.271-.001h-3.73c-.933 0-1.4 0-1.756.182-.314.16-.569.414-.728.728-.182.356-.182.823-.182 1.757v9.666c0 .934 0 1.4.182 1.757.16.314.414.569.728.729.356.181.823.181 1.754.181h6.339c.931 0 1.397 0 1.753-.181.314-.16.57-.415.73-.73.18-.355.18-.821.18-1.753V9.5m-5-5c.239.003.39.012.533.046.17.04.333.108.482.2.168.103.312.247.6.535l2.605 2.605c.288.288.431.432.535.6.09.15.159.312.2.482.034.143.043.294.045.532m-5-5v2.333c0 .934 0 1.4.182 1.757.16.313.415.569.729.729.356.181.822.181 1.754.181h2.335m0 0h0"
        />
    </svg>
);